// This icon file is generated automatically.
var PQuestionOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M9.94 2.39A4 4 0 009 1.1 4.4 4.4 0 006-.05c-1.13 0-2.2.42-3.01 1.16a4 4 0 00-1.27 2.86v.42c0 .1.08.17.17.17h.85c.1 0 .17-.08.17-.17v-.42C2.91 2.4 4.3 1.15 6 1.15S9.09 2.4 9.09 3.97c0 .63-.23 1.23-.66 1.73-.42.5-1.02.85-1.69 1A1.71 1.71 0 005.4 8.38v.5c0 .09.08.17.18.17h.84c.1 0 .18-.08.18-.18v-.49c0-.24.17-.46.4-.51.92-.2 1.75-.7 2.34-1.39a3.94 3.94 0 00.94-2.51c0-.55-.11-1.08-.34-1.58zM6 10.29a.88.88 0 100 1.76.88.88 0 000-1.75z", "fill-rule": "nonzero" } }] }, "name": "p-question", "theme": "outlined" };
export default PQuestionOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PQuestionOutlined.js
// module id = 3571
// module chunks = 0